import React from 'react';
import style from './style.module.scss';

type ReorderTabLayoutProps = {
    children: React.ReactNode;
    history?: React.ReactNode;
    columns?: 1 | 2 | 3;
};

export function ReorderTabLayout({
    children,
    history,
    columns = 2,
}: ReorderTabLayoutProps) {
    const sectionColumnsClass =
        columns === 3 ? style.section_columns_three : style.section_columns;

    return (
        <div className={style.section}>
            <div className={sectionColumnsClass}>{children}</div>
            {history && (
                <div className={style.cms_history_wrapper}>{history}</div>
            )}
        </div>
    );
}
